import React from 'react';
import { connect } from 'react-redux';

import { StagesMenuLayer } from '../../../types';
import { ReduxState } from 'app/redux/types';

import Layer from '../../../components/Layer';
import StagesMenuItems from '../../../components/StagesMenuItems';
import { stagesAndMatchesMenuLayers } from '../../../selectors/prematch';

type StagesMenuLayerProps = {
  entry?: StagesMenuLayer;
};

const PrematchStagesAndMatchesMenuLayer: React.FC<StagesMenuLayerProps> = ({ entry }) => {
  return (
    <Layer level="3"
           header={entry?.header}
           visible={entry?.visible || false}>
      {entry && (
        <StagesMenuItems list={entry?.items} />
      )}
    </Layer>
  );
};

const mapStateToProps = (state: ReduxState): StagesMenuLayerProps => ({
  entry: stagesAndMatchesMenuLayers(state).find((layer) => layer.visible),
});

export default connect(mapStateToProps)(PrematchStagesAndMatchesMenuLayer);
